import React from 'react';
import DsLinkButton, { LinkButtonProps } from '@carvana/ds-link-button';
import { useSlate } from '|/context/slate-context';
import titleCaseChildren from '|/components/carvana-ds/title-case-children';

const LinkButton: React.FC<LinkButtonProps> = ({ children, underline, ...rest }) => {
  const { isSlateVehicle } = useSlate();
  return (
    <DsLinkButton {...rest} underline={isSlateVehicle ? true : underline}>
      {isSlateVehicle ? titleCaseChildren(children) : children}
    </DsLinkButton>
  );
};

export default LinkButton;
export type { LinkButtonProps };
